export class VariableValue {
    constructor(variableName, state, value, timeStamp) {
        this.variableName = variableName;
        this.state = state;
        this.value = value;
        this.timeStamp = timeStamp;
    }
}
